import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentShortInfoDto, DocumentType } from '../../../api/api-client';
import { DateTime } from 'luxon';
import { CardWithTabsComponent } from '../card-with-tabs/card-with-tabs.component';
import { TranslationPipe } from '../../../pipes/translation.pipe';
import { ImageGridComponent } from '../image-grid/image-grid.component';
import { DocumentListComponent } from '../document-list/document-list.component';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { CardWithHeaderComponent } from '../card-with-header/card-with-header.component';

@Component({
  selector: 'app-attachment-gallery',
  imports: [
    CardWithTabsComponent,
    TranslationPipe,
    ImageGridComponent,
    DocumentListComponent,
    ButtonDirective,
    Ripple,
    CardWithHeaderComponent
  ],
  templateUrl: './attachment-gallery.component.html',
  styleUrl: './attachment-gallery.component.scss'
})
export class AttachmentGalleryComponent {
  @Input() pinnedDocuments: DocumentShortInfoDto[] = [];
  @Input() notPinnedDocuments: DocumentShortInfoDto[] = [];
  @Input() pinnedImages: DocumentShortInfoDto[] = [];
  @Input() notPinnedImages: DocumentShortInfoDto[] = [];
  @Input() hasImages: boolean = false;
  @Input() hasDocuments: boolean = false;
  @Input() selectedTab: string = 'left';
  @Input() pinnedTranslationKey: string = 'DocumentList.Pinned';
  @Input() pinLock: boolean = false;
  @Input() deletePinnedLock: boolean = false;


  @Output() onPinDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onUnpinDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onDeleteDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onViewDocument = new EventEmitter<string>();
  @Output() onAddDocument = new EventEmitter<DocumentType>();
  @Output() onEditDocument = new EventEmitter<DocumentShortInfoDto>();

  getDate(date: DateTime) {
    return date.toLocaleString({ day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  pinDocument(document: DocumentShortInfoDto) {
    this.onPinDocument.emit(document);
  }

  unpinDocument(document: DocumentShortInfoDto) {
    this.onUnpinDocument.emit(document);
  }

  openDeleteDocumentDialog(document: DocumentShortInfoDto) {
    this.onDeleteDocument.emit(document);
  }

  openViewDocumentDialog(documentId: string) {
    this.onViewDocument.emit(documentId);
  }

  openAddDocumentDialog(type: DocumentType) {
    this.onAddDocument.emit(type);
  }

  openEditDocumentPage(document: DocumentShortInfoDto) {
    this.onEditDocument.emit(document);
  }
}
